import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import IosController from './controller';
import PushService from 'cio/services/push';
import Transition from '@ember/routing/-private/transition';
import ConfirmChangesService from 'cio/services/confirm-changes';

export default class IosRoute extends Route {
  @service push!: PushService;
  @service confirmChanges!: ConfirmChangesService;

  crumb() {
    return {
      name: 'iOS',
      path: 'actions.push.ios',
    };
  }

  async setupController(controller: IosController, model: any, transition: Transition) {
    super.setupController(controller, model, transition);

    await this.push.loadCredentials.perform();

    controller.refreshProvider();
    this.confirmChanges.register(controller, this);
  }

  resetController(controller: IosController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.setProperties({
        _initialProvider: null,
        provider: null,
        isConfigDirty: false,
        isEditing: false,
      });
    }
  }
}
